import {t, useLanguage} from '../../i18n';
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './BusinessMobileNavigation.css';

export default function BusinessMobileNavigation({ groups, currentLabel, open, onOpenChange, onSelect, isActive, renderIcon }) {
  useLanguage();
  const dialog = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    const node = dialog.current;
    if (open && !node.open) node.showModal();
    if (!open && node.open) { node.close(); trigger.current?.focus(); }
  }, [open]);
  return createPortal(<div className="business-mobile-navigation">
    <button ref={trigger} type="button" className="business-mobile-menu-trigger" aria-haspopup="dialog" aria-expanded={open} onClick={() => onOpenChange(!open)}>
      <span aria-hidden="true">☰</span><span>{t("Menú del negocio")}</span><span className="business-mobile-current">{t(currentLabel)}</span>
    </button>
    <dialog ref={dialog} className="business-mobile-menu-sheet" aria-labelledby="business-mobile-menu-title" onCancel={() => onOpenChange(false)} onClick={event => { if (event.target === event.currentTarget) onOpenChange(false); }}>
      <header><div><h2 id="business-mobile-menu-title">{t("Tu negocio")}</h2><p>{t("Cambia de sección")}</p></div><button type="button" aria-label={t("Cerrar menú del negocio")} onClick={() => onOpenChange(false)}>✕</button></header>
      <nav aria-label={t("Secciones del negocio")}>
        {groups.filter(group => group.items.length).map(group => <section key={group.id}>
          <h3>{t(group.label)}</h3><div className="business-mobile-menu-grid">{group.items.map(item => <button key={item.key} type="button" aria-current={isActive(item) ? 'page' : undefined} onClick={() => { onOpenChange(false); onSelect(item); }}>
            <span className="business-mobile-menu-icon" aria-hidden="true">{renderIcon(item.icon)}</span><span>{t(item.label)}</span>{item.badge ? <small>{item.badge}</small> : null}
          </button>)}</div>
        </section>)}
      </nav>
    </dialog>
  </div>, document.body);
}
